import React, { useState } from "react";
import {
  Badge, Button, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography,
} from "@mui/material";

import MuiIcon from "../../../../../../shared/styles/mui/helpers/mui-icon.helper";
import useRouteHelper from "../../../../../../shared/routes/useRouteHelper.hook";

import csvImg from "../../../../../../shared/images/csv-32x.png";
import xlsImg from "../../../../../../shared/images/xls-32x.png";
import pdfImg from "../../../../../../shared/images/pdf-32x.png";

import MenuButtonComponent from "../../../../../../shared/components/menu-button/menu-button.component";
import useAppStoreContext from "../../../../../../shared/context/app-store/app-store.context";


export default function ReportDataToolbarComponent({
  onReset, onReload, handleColumnsClick, handleFiltersClick, handleEditReportClick,
}: {
  onReload: () => void;
  onReset: () => void;
  handleColumnsClick: () => void;
  handleFiltersClick: () => void;
  handleEditReportClick: () => void;
}) {

  const { selReportDetails, dataSourceName, currentFilters } = useAppStoreContext();
  const { gotoReportListPage } = useRouteHelper();

  const [exportMenuAnchorEl, setExportMenuAnchorEl] = useState<HTMLElement | null>(null);
  const openExportMenu = Boolean(exportMenuAnchorEl);

  const handleExcelExportClick = () => setExportMenuAnchorEl(null);
  const handleCsvExportClick = () => setExportMenuAnchorEl(null);
  const handlePdfExportClick = () => setExportMenuAnchorEl(null);


  return (
    <Grid paddingX={2} container direction="row" alignItems="center" justifyContent="flex-start">


      {/* Reload */}
      {/* TODO: put a hard reload that clears current filters/columns and defaults to default values */}
      <MenuButtonComponent text="" size="small" color="secondary" menuButtonColor="primary"
        variant="outlined" buttonVariant="text" menuButtonVariant="text"
        onClick={() => gotoReportListPage()} buttonIcon={MuiIcon.BACK()}
        menuButtonText={`${selReportDetails?.reportName || 'loading...'} ${dataSourceName ? `- ${dataSourceName}` : ""}`}
        menuButtonIcon={MuiIcon.RELOAD()}
      >
        <MenuItem onClick={onReload}>
          <ListItemIcon color="secondary">
            {MuiIcon.RELOAD({ sx: { color: (t) => t.palette.secondary.main } })}
          </ListItemIcon>
          <ListItemText sx={{}}>Reload Report</ListItemText>
        </MenuItem>

        <MenuItem onClick={onReset}>
          {/* TODO: hard reload */}
          <ListItemIcon color="error">
            {MuiIcon.CLEAR_ALL({ sx: { color: (t) => t.palette.error.main } })}
          </ListItemIcon>
          <ListItemText sx={{ color: (t) => t.palette.error.dark }}>
            Reset Changes
          </ListItemText>
        </MenuItem>
      </MenuButtonComponent>

      {/* Title */}
      <Typography sx={{ ml: 1, flexGrow: 1, textAlign: "start" }} variant="subtitle2"></Typography>

      {/* Export */}
      <Tooltip title='Edit Report Wizard'>
        <Button sx={{ mr: 2 }} color='primary' variant='outlined' onClick={handleEditReportClick} startIcon={MuiIcon.WIZARD()}>Edit Report</Button>
      </Tooltip>

      {/* Filters */}
      <Tooltip title="Filters">
        <IconButton color={currentFilters.length ? "primary" : "default"} onClick={handleFiltersClick}>
          <Badge color="secondary" badgeContent={currentFilters.length}>
            {MuiIcon.FILTER()}
          </Badge>
        </IconButton>
      </Tooltip>

      {/* Columns */}
      <Tooltip title="Columns">
        <IconButton color="primary" onClick={handleColumnsClick}>
          {MuiIcon.COLUMNS()}
        </IconButton>
      </Tooltip>

      {/* Export */}
      <Tooltip title="Export">
        <IconButton color="success" onClick={(e) => setExportMenuAnchorEl(e.currentTarget)}>
          {MuiIcon.DOWNLOAD()}
        </IconButton>
      </Tooltip>

      {/* Export Menu */}
      <Menu anchorEl={exportMenuAnchorEl} open={openExportMenu} onClose={() => setExportMenuAnchorEl(null)}
        PaperProps={{ style: { width: "218px", paddingLeft: "4px" } }}
      >
        <MenuItem onClick={handleExcelExportClick} sx={{ mt: 0 }}>
          <ListItemIcon>
            <img src={xlsImg} alt="XLS" style={{ paddingLeft: "4px" }} width="22px" height="20px" />
          </ListItemIcon>
          <ListItemText sx={{ ml: 1 }}>Excel</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleCsvExportClick} sx={{ mt: 1 }}>
          <ListItemIcon>
            <img src={csvImg} alt="CSV" width="20px" height="20px" />
          </ListItemIcon>
          <ListItemText sx={{ ml: 1 }}>CSV</ListItemText>
        </MenuItem>

        <MenuItem onClick={handlePdfExportClick} sx={{ mt: 1 }}>
          <ListItemIcon>
            <img src={pdfImg} alt="PDF" width="20px" height="20px" />
          </ListItemIcon>
          <ListItemText sx={{ ml: 1 }}>PDF</ListItemText>
        </MenuItem>
      </Menu>
    </Grid>
  );
}
